// src/services/v4PublicApi.js
import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import config from "../config";

/**
 * One shared RTK Query api for the v4 public pages. It never sends the admin
 * Bearer token, so a public page always gets the public view even when an
 * admin is logged in on the same browser.
 *
 * Pages add their endpoints from their own files with
 * v4PublicApi.injectEndpoints({ endpoints: (builder) => ({ ... }) }),
 * so no page edits this file or the store.
 */
const resolveBaseUrl = () => {
  if (typeof window !== "undefined" && window.__API_BASE_URL) {
    return window.__API_BASE_URL;
  }
  return config?.api?.baseURL ?? "";
};

const v4PublicApi = createApi({
  reducerPath: "v4PublicApi",
  baseQuery: fetchBaseQuery({ baseUrl: `${resolveBaseUrl()}/` }),
  tagTypes: ["V4Month", "V4Reviews", "V4Gallery", "V4Audio", "V4Songs"],
  endpoints: () => ({}),
});

export default v4PublicApi;
export { v4PublicApi };
